import React from 'react'
import './LibrarySubjectCM.css'
import { Tooltip } from '@mui/material'
import { shortenParagraph } from '../../../utils/Engagement'

export default function LibrarySubjectCM(props) {
  return (
    <div className='d-flex gap-3 toatal_library_container' >
      <img src={props.sublogo} alt='subject logo' className='sub-icon'></img>
      <div>
        <div className='LibraySubject'>
          <Tooltip
            title={props.subname}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={100}
          >
            <div>
              {shortenParagraph(props.subname, 20)}
            </div>
          </Tooltip>
        </div>
        <div className='bookList'>{props.bookList}</div>
      </div>
    </div>
  )
}
